<template>
  <div :class="$style.modal">
    <div>
      <ModalHeader
        :handleClose="handleClose"
        :headerText="headerText"
        :showClose="true"
      />
      <div
        v-if="agentType === importAgent"
        :class="$style.modalBody"
      >
        <p>
          Before you install this agent, make sure you have the recommended system requirements
          and installation prerequisites:
          <a
            :href="ADImportAgentKB"
            rel="noopener noreferrer"
            target="_blank"
          >
            Installation Guide
          </a>. Additionally, to prevent failed imports, make sure that your AD and JumpCloud
          password complexity requirements are consistent for any users you’re importing.
        </p>
        <p>
          Save the downloaded installer to your Domain Controller, then run the installer
          and enter the information below when prompted.
        </p>
        <CopyWell
          :content="user.apiKey"
          label="Enter this JumpCloud API key when prompted"
          location="Download AD Bridge API Key"
          :rows="1"
        />
        <CopyWell
          :content="orgId"
          label="Enter your JumpCloud Organization ID when prompted"
          location="Download AD Bridge Org ID"
          :rows="1"
        />
        <p>
          Your AD Domains will display in the Directories list once the Import Agent has
          successfully installed. You may then view and edit the agents installed on each
          Domain.
        </p>
      </div>
      <div
        v-else
        :class="$style.modalBody"
      >
        <p>
          Before you install this agent, make sure you have the recommended system requirements
          and installation prerequisites:
          <a
            :href="ADSyncAgentKB"
            rel="noopener noreferrer"
            target="_blank"
          >
            Installation Guide
          </a>. Additionally, for JumpCloud to inform users of required resets and accurately sync
          updates, make sure that your AD and JumpCloud password complexity requirements and
          expiration settings are consistent for any users in this AD Integration Domain.
        </p>
        <p>
          Save the downloaded installer to your Domain Controller, then run the installer
          and enter the information below when prompted. This key is specific to this installation.
        </p>
        <CopyWell
          :content="connectKey"
          label="Enter this Installation Connect Key when prompted"
          location="Download AD Bridge Connect Key"
          :rows="1"
        />
        <p>
          You may view and edit successfully installed agents in the Domain Agents tab.
        </p>
      </div>
      <ModalFooter
        cancelText="close"
        :handleClose="handleClose"
        :handleMainAction="handleClose"
        :mainActionText="''"
      />
    </div>
  </div>
</template>
<script>
import * as Constants from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import CopyWell from 'client/components/FormValidation/CopyWell.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

const { AdBridgeAgentTypes } = Constants;

export default {
  name: 'DownloadAdBridgeAgentModal',

  components: {
    CopyWell,
    ModalFooter,
    ModalHeader,
  },

  props: {
    agentType: {
      type: String,
      required: true,
      validator(value) {
        return AdBridgeAgentTypes[value] !== undefined;
      },
    },
    connectKey: {
      type: String,
      default: Constants.default.dataNotAvailable,
    },
  },

  data() {
    return {
      ...AdBridgeAgentTypes,
    };
  },

  computed: {
    ...mapGetters('SettingsModule', {
      user: 'getUser',
    }),

    ...mapState('SettingsModule', {
      orgId: 'orgId',
      ADImportAgentKB: state => state.staticUrls.ADImportAgentKB,
      ADSyncAgentKB: state => state.staticUrls.ADSyncAgentKB,
    }),

    headerText() {
      return `Install ${this.agentType === this.importAgent ? 'Import' : 'Sync'} Agent`;
    },
  },

  methods: {
    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>
<style module>
@import '../../components/Modal/css/ModalStyles.css';
</style>
